export default function scrollLink() {
    $('a[href*="#"]:not(.tab-button)').on('click', function (e) {

        var page        = window.location.href;
        var page_url    = page.split('#');
        var link        = $(this)[0].href;
        var link_url    = link.split('#');

        if( link_url[0] === page_url[0] && link_url[1]){
            e.preventDefault();
            var hash    = $(this)[0].hash;
            var _scroll = $(hash).offset().top - $('.header').outerHeight() - 20;
            
            $([document.documentElement, document.body]).animate({
                scrollTop: _scroll
            }, 850);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorLink.js